<div class="modal-header">
  <div class="row w-100 align-items-center">
    <div class="col-lg-6">
      <div class="text-header inc-f pl-3">
        <span class="fa fa-list"></span> Import Updates
      </div>
    </div>
    <div class="col-lg-6 px-0 text-right">
      <!-- <button class="fa fa-times pull-right" [mat-dialog-close]="" style="cursor: pointer;background: none;border:none"
          aria-hidden="true"></button> -->
      <button (click)="Save()" class="external_update_save_btn">{{saveButtonText}}</button>
      <button class="fa fa-times" [mat-dialog-close]="" style="cursor: pointer;background: none;"
        aria-hidden="true"></button>
    </div>
  </div>


</div>
<!-- <div class="modal-body"> -->

<div class="modal-body custom-body">
  <div class="upperpart">
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation" (click)="tabSelection('single')">
        <button class="nav-link" [ngClass]="isSingle==true? 'active' : ''" id="single-tab" data-bs-toggle="tab" data-bs-target="#single-tab-pane" type="button"
          role="tab" aria-controls="single-tab-pane" aria-selected="true">Single Import</button>
      </li>
      <li class="nav-item" role="presentation" (click)="tabSelection('bulk')">
        <button class="nav-link" [ngClass]="isSingle==false? 'active' : ''" id="bulk-tab" data-bs-toggle="tab" data-bs-target="#bulk-tab-pane"
          type="button" role="tab" aria-controls="bulk-tab-pane" aria-selected="false">Bulk Import</button>
      </li>
    </ul>
    <hr>
    <div class="tab-content mt-4" id="myTabContent">
      <div class="tab-pane fade" [ngClass]="isSingle==true? 'show active' : ''"  id="single-tab-pane" role="tabpanel" aria-labelledby="single-tab" tabindex="0">
        <app-add-single-manual-update [regulationId]="id"></app-add-single-manual-update>
      </div>
      <div class="tab-pane fade" [ngClass]="isSingle==false? 'show active' : ''" id="bulk-tab-pane" role="tabpanel" aria-labelledby="bulk-tab"
        tabindex="0">
        <app-bulk-import-manual-update (isShowErrorMessage)="addItem($event)"></app-bulk-import-manual-update>
      </div>
  
    </div>
  </div>

  <div class="downpart text-right mt-4 pr-0" *ngIf="isShowErrorMessage">
    <div class="alert alert-danger">
        <p>Data Validation Error: Please check the highlighted fields. </p>
        <p>(Only alphanumeric input is allowed. Max character limit for Geography, Country and Regulator is 50.)</p>
    </div>
</div>
</div>

